<template>
    <v-card flat color="transparent" class="mb-12">
        <v-card-text
            class="py-0 d-flex"
            :class="mdAndUp ? 'justify-start pl-4' : 'justify-center'"
        >
            <div class="d-flex align-center">
                <v-icon color="textLight" class="mx-2" v-if="!isMobile"
                    >mdi-floor-plan</v-icon
                >
                <span class="text-body-1 text-textLight text-no-wrap">{{
                    stand.numero
                }}</span>
                <v-icon color="textLight" class="mx-2"
                    >mdi-chevron-right</v-icon
                >
                <span class="text-body-1 text-textLight">
                    {{ stand.usuario_principal.nombre }}</span
                >
            </div>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { useDisplay } from "vuetify";
import { computed } from "vue";
const { smAndDown, mdAndUp } = useDisplay();

const isMobile = computed(() => {
    return smAndDown.value;
});

const props = defineProps({
    stand: {
        type: Object,
        required: true,
    },
});
</script>
